import { IonRouterOutlet, IonTabBar, IonTabs, IonTabButton } from '@ionic/react';
import { addCircle, gitCompareOutline, home } from 'ionicons/icons';
import React from 'react';
import { Route, useHistory } from 'react-router-dom';
import { t } from 'ttag';

import RoutePath from '@custom-types/RoutePath';
import { Icon, Label } from '@pages/Event/Tabs';
import { generateRoute } from '@services/navigation-service';

import Add from './Add';
import Home from './Home';
import List from './List';

/* eslint-disable @typescript-eslint/no-shadow */
enum Tabs {
  Home = 'home',
  Add = 'add',
  List = 'list',
}
/* eslint-enable @typescript-eslint/no-shadow */

const LeadTabs = () => {
  const history = useHistory();

  /*
    For Tabs.List we need to refresh the page and Tab doesn't allow that so we have to use history navigation to keep the lead list updated
  */
  const onIonTabsDidChange = ({ detail: { tab } }: CustomEvent<{ tab: string }>) => {
    if (tab === Tabs.Home) {
      history.replace(generateRoute(RoutePath.LeadHome));
    }
    if (tab === Tabs.Add) {
      history.replace(generateRoute(RoutePath.LeadAdd));
    }
    if (tab === Tabs.List) {
      history.replace(generateRoute(RoutePath.LeadList));
    }
  };

  return (
    <IonTabs>
      <IonRouterOutlet>
        <Route path={generateRoute(RoutePath.LeadHome)} exact>
          <Home />
        </Route>
        <Route path={generateRoute(RoutePath.LeadAdd)} exact>
          <Add />
        </Route>
        <Route path={generateRoute(RoutePath.LeadList)} exact>
          <List />
        </Route>
      </IonRouterOutlet>
      <IonTabBar
        slot="bottom"
        // skipcq: JS-0417
        onIonTabsDidChange={onIonTabsDidChange}
      >
        <IonTabButton tab={Tabs.Home} href={generateRoute(RoutePath.LeadHome)}>
          <Icon icon={home} />
          <Label>{t`Home`}</Label>
        </IonTabButton>
        <IonTabButton tab={Tabs.Add} href={generateRoute(RoutePath.LeadAdd)}>
          <Icon icon={addCircle} />
          <Label>{t`Add Leads`}</Label>
        </IonTabButton>
        <IonTabButton tab={Tabs.List} href={generateRoute(RoutePath.LeadList)}>
          <Icon icon={gitCompareOutline} />
          <Label>{t`Lead Collection`}</Label>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default LeadTabs;
